export default __webpack_public_path__ + "static/media/rodape.952142b4.jpg";